import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-511077d5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "hit-module-list-root bg-table rounded border border-table",
    style: { "max-height": "calc(100vh - 13.2rem)" }
};
const _hoisted_2 = { class: "sticky top-0 z-10 bg-table module-list-header" };
const _hoisted_3 = { class: "whitespace-nowrap sm:rotate-0 rotate-90 sm:writing-mode-horizontal-tb writing-mode-vertical-rl sm:h-auto h-[80px] sm:text-sm text-xs sm:leading-normal leading-[2rem] max-w-full flex items-center justify-center" };
const _hoisted_4 = { class: "hidden sm:block" };
const _hoisted_5 = { class: "text-right text-xs sm:text-sm" };
const _hoisted_6 = { class: "text-xs sm:text-sm" };
const _hoisted_7 = { class: "text-xs sm:text-sm" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_module_list_cell = _resolveComponent("hit-module-list-cell");
    const _component_hit_module_list_row = _resolveComponent("hit-module-list-row");
    const _component_hit_icon = _resolveComponent("hit-icon");
    const _component_hit_dialog = _resolveComponent("hit-dialog");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: "hit-module-list relative overflow-y-auto",
            style: _normalizeStyle(_ctx.cssProps)
        }, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_hit_module_list_row, { class: "border-b border-table" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_hit_module_list_cell),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldsToDisplay, (field, idx) => {
                            return (_openBlock(), _createBlock(_component_hit_module_list_cell, {
                                key: idx,
                                "justify-content": _ctx.getHeaderJustifyContentProperty(idx),
                                "display-border": idx < _ctx.fieldsToDisplay.length - 1,
                                class: "text-xs font-bold overflow-hidden flex-1"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(field.translation), 1)
                                ]),
                                _: 2
                            }, 1032, ["justify-content", "display-border"]));
                        }), 128))
                    ]),
                    _: 1
                })
            ]),
            _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mergedModules, (module, idx) => {
                    return (_openBlock(), _createBlock(_component_hit_module_list_row, {
                        key: module.designationKey + '-' + idx,
                        class: _normalizeClass({
                            'border-b border-table': _ctx.mergedModules[idx + 1] &&
                                _ctx.mergedModules[idx + 1].parentId === null,
                        })
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_hit_module_list_cell, { "justify-content": 'center' }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                        (module.iconKey)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass([
                                                    'flex items-center justify-center vertical-align h-10 w-10 ',
                                                    `bg-${module.designationKey}`,
                                                ])
                                            }, [
                                                _createVNode(_component_hit_icon, {
                                                    icon: module.iconKey,
                                                    color: "white",
                                                    size: "md"
                                                }, null, 8, ["icon"])
                                            ], 2))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(_component_hit_module_list_cell, { "justify-content": 'left' }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["ml-2 sm:ml-5 text-left text-xs sm:text-sm break-words overflow-hidden text-ellipsis", { 'font-bold': module.parentId === null }])
                                    }, _toDisplayString(_ctx.t(`hit-components.modules.basic.${module.designationKey}.designation`)), 3)
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(_component_hit_module_list_cell, { "justify-content": 'right' }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(module.userCount), 1)
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(_component_hit_module_list_cell, { "justify-content": 'right' }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(module.price !== null && module.price !== undefined
                                        ? module.price.toFixed(2) + ' €'
                                        : ''), 1)
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(_component_hit_module_list_cell, { "justify-content": 'right' }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(module.total !== null && module.total !== undefined
                                        ? module.total.toFixed(2) + ' €'
                                        : ''), 1)
                                ]),
                                _: 2
                            }, 1024)
                        ]),
                        _: 2
                    }, 1032, ["class"]));
                }), 128))
            ])
        ], 4),
        _createVNode(_component_hit_dialog, {
            visible: _ctx.showModuleFullDescriptionDialogScreen,
            title: _ctx.showModuleFullDescriptionTitle,
            color: "accent",
            "cancel-button-label": _ctx.t('hit-components.common.close'),
            "show-cancel-button": true,
            "show-ok-button": false,
            class: "z-30",
            onCancel: _ctx.onCancelShowFullDescriptionDialogScreen
        }, {
            body: _withCtx(() => [
                _createElementVNode("div", {
                    class: "whitespace-pre-wrap m-2 max-h text-xs sm:text-sm overflow-y-auto overflow-x-hidden text-justify",
                    innerHTML: _ctx.showModuleFullDescriptionText
                }, null, 8, _hoisted_8)
            ]),
            _: 1
        }, 8, ["visible", "title", "cancel-button-label", "onCancel"]),
        _createVNode(_component_hit_dialog, {
            visible: _ctx.showConfirmUserModuleModification,
            "v-show": _ctx.showConfirmUserModuleModification,
            title: _ctx.t('hit-components.modules.user-modules-modification'),
            color: "accent",
            message: _ctx.t('hit-components.modules.please-confirm-user-modules-modification'),
            "ok-button-label": _ctx.t('hit-components.common.confirm'),
            "ok-button-icon": "success",
            "ok-button-color": "accent",
            "cancel-button-icon": "clear",
            "cancel-button-label": _ctx.t('hit-components.common.cancel'),
            "show-cancel-button": true,
            class: "z-30",
            onOk: _ctx.onConfirmUserModuleModification,
            onCancel: _ctx.onCancelUserModuleModification
        }, null, 8, ["visible", "v-show", "title", "message", "ok-button-label", "cancel-button-label", "onOk", "onCancel"]),
        _createVNode(_component_hit_dialog, {
            visible: _ctx.showHowToChooseModulesDialog,
            "v-show": _ctx.showHowToChooseModulesDialog,
            title: _ctx.t('hit-components.modules.how_to_choose_modules_title'),
            color: "accent",
            class: "z-30",
            message: _ctx.t('hit-components.modules.please-confirm-user-modules-modification'),
            "cancel-button-icon": "clear",
            "cancel-button-label": _ctx.t('hit-components.common.cancel'),
            "show-cancel-button": true,
            "show-ok-button": false,
            onCancel: _ctx.onCancelHowToChooseModules
        }, {
            body: _withCtx(() => [
                _createElementVNode("div", {
                    innerHTML: _ctx.t('hit-components.modules.how_to_choose_modules_content')
                }, null, 8, _hoisted_9)
            ]),
            _: 1
        }, 8, ["visible", "v-show", "title", "message", "cancel-button-label", "onCancel"])
    ]));
}
